import CheckoutFooter from '@/components/cart/footer/CartFooter';

export default CheckoutFooter;
